import GADashboard from '../../components/analytics/GADashboard';
import './AnalyticsPage.css';

function AnalyticsPage() {
  return (
    <div className="analytics-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <h1>Analytics</h1>
          <p>Track your website traffic and visitor insights with Google Analytics.</p>
        </div>
      </div>

      {/* Google Analytics Dashboard */}
      <GADashboard />
    </div>
  );
}

export default AnalyticsPage;
